import React, {useReducer, useState} from "react"
import {useHistory, useLocation, useParams} from "react-router-dom"
import {createQueryFn, useSolv} from "./components/SolvProvider"
import {useIntlEx} from "./components/IntlUtils"
import Turnstile, {useTurnstile} from "react-turnstile"
import {
  ActionButton,
  Div,
  FormGroup,
  FormGroups,
  Icon,
  MainContainer,
  OtpInput,
  SelectList,
  UrlInput,
  useAlert
} from "./components/FormComps"
import {PageDialog, PageDialogContainer, PageDialogMainPanel} from "./components/PageDialog"
import {isBlankString} from "./components/StringUtils"
import {PageDialogFooter, PageDialogHeader, PageDialogSider} from "./components/PageDialogComps";
import {AsyncPaginate} from "react-select-async-paginate";
import {simpleReducer} from "./components/ReactUtils";
import {default as Select} from "react-select";
import {
  getSelfSignupFieldOptionFromValue,
  getSelfSignupFieldValueFromOption,
  gotoDest,
  peekReferrer,
  selfSignupEtcFieldDefs
} from "./components/SigninupUtils";
import {GoogleButton} from "./components/GoogleButton";
import {LinkedInButton} from "./components/LinkedInButton";
import {useQuery} from "react-query";
import getLogger from "./components/Logging.js"
import './App.css'

const log = getLogger("Signup")

// function hashToStep(hash) {
//   if (hash) {
//     if (hash.startsWith("#")) {
//       log.debug(">>>Z: hash=", hash.slice(1).toUpperCase())
//       return hash.slice(1).toUpperCase()
//     }
//     else {
//       return hash.toUpperCase()
//     }
//   }
//   else {
//     return "START"
//   }
// }
//
export default function Signup(props) {

  const {api, auth: {signup, generateOtp}, env, setBusy, setFatal} = useSolv()
  const {intl} = useIntlEx()

  const params = useParams()
  const location = useLocation()
  const history = useHistory()

  const turnstile = useTurnstile()

  const queryParams = new URLSearchParams(location.search)

  const [alert, setAlert] = useAlert()

  const [signupCode, setSignupCode] = useState(params.signupCode)
  const [magicCode, setMagicCode] = useState(params.magicCode)
  const [signupType, setSignupType] = useState(null)
  const [turnstileVerified, setTurnstileVerified] = useState(false)
  const [fullName, setFullName] = useState(queryParams.get(null))
  const [emailAddress, setEmailAddress] = useState(queryParams.get("emailAddress"))
  const [step, setStep] = useState("PREVERIFICATION")
  const [country, setCountry] = useState(null)
  const [etc, updateEtc] = useReducer(simpleReducer, {})
  const [authenticatedPayload, setAuthenticatedPayload] = useState(null)
  const [aliasedAccounts, setAliasedAccounts] = useState(null)
  const [aliasedAccount, setAliasedAccount] = useState(null)
  const [generateVerifyEmailClickCount, setGenerateVerifyEmailClickCount] = useState(0)

  const {data: signupCodeInfo, isLoading: signupCodeInfoLoading} = useQuery({
    queryFn: createQueryFn(api.getSignupCodeInfo, params.signupCode),
    queryKey: ["signupCodeInfo", params.signupCode],
    onError: (error) => (error),
    onSuccess: (data) => {
      log.debug(">>>Z: signupCodeInfo: data=", data)
      if (data?.inviterTenant?.brandId !== env.brandId) {
        handleError({code: "INVALID_REFERRAL_CODE"})
      }
      else {
        setSignupType(data.signupType)
        if (data?.inviteeUser?.fullName) {
          setFullName(data.inviteeUser.fullName)
        }
        if (data?.inviteeUser?.emailAddress) {
          setEmailAddress(data.inviteeUser.emailAddress)
        }
      }
    },
    enabled: !!params.signupCode
  })

  // useEffect(() => {
  //   setBusy(signupCodeInfoLoading ? intl.msg("checking") : null)
  // }, [signupCodeInfoLoading])

  function handleTurnstileSuccess(token) {
    setTurnstileVerified(true)
    setStep(params.signupCode ? "INVITED_SIGNUP" : "SELF_SIGNUP")
  }

  async function handleAliasedAccountChange(v) {
    setAliasedAccount(v)
    let payload = authenticatedPayload
    payload.emailAddress = v.value
    setBusy(intl.msg("working"))
    try {
      await doSignup(payload)
    }
    finally {
      setBusy(null)
    }
  }

  function handleEmailAddressChange(e) {
    e.preventDefault()
    setEmailAddress(e.target.value)
  }

  function handleFullNameChange(e) {
    e.preventDefault()
    setFullName(e.target.value)
  }

  function handleCountryChange(v) {
    setCountry(v)
  }

  function handleEtcFieldInputChange(field) {
    return function (e) {
      updateEtc({[field]: e.target.value})
    }
  }

  function handleEtcFieldSelectChange(field) {
    return function (o) {
      const v = getSelfSignupFieldValueFromOption(o)
      updateEtc({[field]: v})
    }
  }

  // useEffect(() => {
  //   log.debug("signupCodeInfo=", signupCodeInfo)
  //   if (signupCodeInfo) {
  //     setStep("SELF_SIGNUP")
  //   }
  // }, [signupCodeInfo])

  async function handleGoogleLoginSuccess(response) {
    // log.debug("googleHandleSuccessfulLogin: response=", response)
    let payload = {}
    if (signupCodeInfo) {
      payload = {
        op: "SIGN_UP",
        emailAddress: emailAddress,
        idProvider: "GOOGLE",
        signupCode: signupCode,
        signupType: signupCodeInfo.signupType,
        // tenantName: response.profileObj.emailAddress,
        profileObj: response.profileObj,
      }
    }
    else {
      payload = {
        op: "SIGN_UP",
        idProvider: "GOOGLE",
        signupCode: null,
        signupType: "SELF",
        profileObj: response.profileObj,
      }
    }
    setAuthenticatedPayload(payload)
    doSignup(payload)
  }

  function handleGoogleLoginError(response) {
    setAlert({type: "error", text: intl.msg("error_failed_google_auth")})
  }

  async function handleLinkedInLoginSuccess(response) {
    let payload = {}
    if (signupCodeInfo) {
      payload = {
        op: "SIGN_UP",
        emailAddress: emailAddress,
        idProvider: "LINKEDIN",
        signupCode: signupCode,
        signupType: signupCodeInfo.signupType,
        code: response,
      }
    }
    else {
      payload = {
        idProvider: "LINKEDIN",
        sigmupCode: null,
        signupType: "SELF",
        code: response,
      }
    }
    doSignup(payload)
  }

  function handleLinkedInLoginError(response) {
    // log.debug("handleLinkedInLoginError", response)
    setAlert({type: "error", text: intl.msg("error_failed_linkedin_auth")})
  }

  function handleOtpChange(v) {
    const payload = {
      op: "SIGN_UP",
      idProvider: "OTP",
      otp: v,
    }
    doSignup(payload)
  }

  function loadCountries(search, loadedOptions, additional) {
    return api.listCountriesPublic({view: "BASIC", extraParams: `filter=displayName:${encodeURIComponent(search)}&sort=displayName:ASC`, cursor: additional?.cursor, limit: 20})
      .then(({data, nextCursor}) => {
        // log.debug("loadCountries: data=", data)
        let opt = data.map(c => {
          return {
            value: c.countryCode,
            label: c.displayName,
          };
        });
        let res = {
          options: opt,
        }
        if (nextCursor) {
          res = {
            ...res,
            hasMore: true,
            additional: {
              cursor: nextCursor
            }
          }
        }
        // log.debug("loadRegions: res=", res)
        return res
      });
  }

  function doSignup(payload) {
    setAlert(null)
    setBusy(intl.msg("working"))

    signup({...payload, op: "SIGN_UP", appVer: env.APP_VERSION})
      .then((data) => {
        log.debug(">>>Z: data=", data)
        if ("REGISTERED" === data?.status) {
          setStep("SELF_SIGNUP_REGISTERED")
        }
        else {
          gotoDest(props, data)
        }
      })
      .catch((error) => {
        handleError(error)
      })
      .finally(() => {
        setBusy(null)
      })
  }

  async function generateVerifyEmail() {

    if (isBlankString(emailAddress)) {
      setAlert({type: "error", text: "Please enter all the details below."})
      return
    }

    if ("SELF" === signupType && !country) {
      setAlert({type: "error", text: "Please enter all the details below."})
      return
    }

    let params = {
      idProvider: "OTP",
      dest: peekReferrer()
    }

    if (signupCodeInfo) {
      params.signupType = signupCodeInfo.signupType
      params.signupCode = signupCodeInfo.signupCode
    }
    else {
      params.signupType = "SELF"
      params.countryCode = country.value
      params.etc = etc
    }

    let payload = {
      op: "SIGN_UP",
      fullName: fullName,
      emailAddress: emailAddress,
      params: params
    }

    setBusy(intl.msg("working"))

    try {

      await generateOtp(payload)

      setAlert(null)
      setGenerateVerifyEmailClickCount(prev => (prev || 0) + 1)
      setStep("CHECK_OTP")

    }
    catch (error) {
      handleError(error)
    }
    finally {
      setBusy(null)
    }

  }

  function handleSignupRequestNextClick(e) {
    setStep("SELF_SIGNUP_PAGE_2")
  }

  function handleSignupRequestPrevClick(e) {
    setStep("SELF_SIGNUP")
  }

  function handleError(error) {
    log.debug("handleError: error=", error)
    if (error && error.code) {
      const code = error.code
      switch (code) {
        case "MISMATCHED_EMAIL_ADDRESS":
          setAlert({type: "error", text: intl.msg("signup_error_mismatched_email_address")})
          break
        case "MULTIPLE_ALIASED_ACCOUNTS":
          if (error.details?.accounts) {
            const opts = error.details.accounts.map(a => {
              return ({
                label: `${a.tenantName} (${a.emailAddress })`,
                value: a.emailAddress,
              })
            })
            opts.sort((a, b) => a.label.localeCompare(b.label));
            setAliasedAccounts(opts)
            setAliasedAccount(null)
            setAlert(null)
            setStep("SELECT_ALIASED_ACCOUNT")
          }
          else {
            setAlert({type: "error", text: intl.msg("error_failed")})
          }
          break
        case "UNKNOWN_OTP":
          setAlert({type: "error", text: intl.msg("signup_error_unknown_otp")})
          break
        case "INVALID_OTP":
          setAlert({type: "error", text: intl.msg("signup_error_invalid_otp")})
          break
        case "UNKNOWN_SIGNUP_CODE":
        case "INVALID_SIGNUP_CODE":
        case "INVALID_REFERRAL_CODE":
        case "ILLEGAL_REFERRAL":
        case "UNAUTHORIZED":
        case "NOT_FOUND":
          setAlert({type: "error", text: intl.msg("signup_error_invalid_signup_code")})
          break
        case "UNKNOWN_INVITER":
        case "INVALID_INVITER":
          setAlert({type: "error", text: intl.msg("signup_error_invalid_inviter")})
          break
        case "INVALID_INVITEE":
          setAlert({type: "error", text: intl.msg("signup_error_invalid_invitee")})
          break
        case "ALREADY_SIGNED_UP":
          setAlert({type: "error", text: intl.msg("signup_error_already_signed_up")})
          break
        case "DUPLICATE_KEY":
        case "DUPLICATE_USER":
        case "DUPLICATE_INVITEE_USER":
          setAlert({type: "error", text: intl.msg("signup_error_duplicate_user", {emailAddress: error.details?.emailAddress || ""})})
          break
        case "DUPLICATE_INVITEE_TENANT":
          setAlert({type: "error", text: intl.msg("signup_error_duplicate_tenant", {tenantName: error.details?.tenantName || ""})})
          break
        case "BANNED_INVITER":
        case "BANNED_USER":
        case "BANNED_REMOTE_ADDRESS":
          setAlert({type: "error", text: intl.msg("error_banned_user")})
          break
        case "BANNED_EMAIL_ADDRESS":
          setAlert({type: "error", text: intl.msg("error_banned_email_address")})
          break
        case "INVALID_EMAIL_ADDRESS":
          setAlert({type: "error", text: intl.msg("error_invalid_email_address")})
          break
        case "INVALID_RECAPTCHA":
          setAlert({type: "error", text: intl.msg("error_invalid_recaptcha")})
          break
        case "INVALID_MAGIC_LINK":
          setAlert({type: "error", text: intl.msg("error_invalid_magic_link")})
          break
        case "DUPLICATE_MAGIC_LINK":
          setAlert({type: "error", text: intl.msg("error_duplicate_magic_link")})
          break
        case "ONBOARDING":
          // doCompleteOnboarding()
          break
        case "UNAVAILABLE":
          window.location = "/unavailable"
          break
        default:
          setAlert({type: "error", text: intl.msg("error_failed")})
      }
    }
    else {
      setAlert({type: "error", text: intl.msg("error_failed")})
    }
  }

  function mkLink(prefix, hash) {
    if (props.location?.state?.referrer) {
      queryParams.set("dest", `${props.location.state.referrer.pathname}${props.location.state.referrer.search}${props.location.state.referrer.hash}`)
    }
    return `${prefix || "/signup"}/${signupCode}?${queryParams.toString()}${hash || ""}`
  }

  function isSelfSignup() {
    return (!params.signupCode) && (!["INVITED_TENANT", "INVITED_MEMBER", "REFERRAL"].includes(signupType))
  }

  function hasSelfSignupEtcFields() {
    return Array.isArray(env.selfSignupEtcFields) && env.selfSignupEtcFields.length > 0
  }

  return (
    <MainContainer>
      <PageDialogContainer>
        <PageDialog header={PageDialogHeader} sider={PageDialogSider} footer={PageDialogFooter} size="md" align="center">
          {
            ["PREVERIFICATION"].includes(step) ? (

                <PageDialogMainPanel>
                <div className="d-flex flex-row align-items-center" style={{minHeight: "300px"}}>
                  <Turnstile
                    sitekey={env.turnstileSiteKey}
                    theme="auto"
                    onSuccess={handleTurnstileSuccess}
                  />
                </div>
              </PageDialogMainPanel>

            ) : ["CHECK_OTP"].includes(step) ? (

              <PageDialogMainPanel title={intl.msg("check_otp_title")} alert={alert}>
                <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                  <p className="mt-1">
                    {intl.msg("check_otp_text_1", {brand: env.displayName, emailAddress: emailAddress})}
                  </p>

                  <div className="mt-2" style={{width: "440px"}}>
                    <OtpInput length={8} onChange={handleOtpChange}/>
                  </div>

                  <p className="mt-3">
                    {intl.msg("check_otp_text_2", {brand: env.displayName, emailAddress: emailAddress})}
                    {
                      generateVerifyEmailClickCount <= 1 ? (
                        intl.msg("check_otp_text_3", {brand: env.displayName, emailAddress: emailAddress, a_regenOtp: (chunks) => <a className="text-link" href="#" onClick={generateVerifyEmail}>{chunks}</a>})
                      ) : (
                        <></>
                      )
                    }
                  </p>

                </div>
              </PageDialogMainPanel>

            ) :  (["SELECT_ALIASED_ACCOUNT"].includes(step)) ? (

              <PageDialogMainPanel title={intl.msg("multiple_aliased_accounts_title")} alert={alert}>
                <p className="mt-3">
                  {intl.msg("multiple_aliased_accounts_text", {brand: env.displayName, emailAddress: emailAddress})}
                </p>
                <SelectList id="inp_account" value={aliasedAccount} options={aliasedAccounts} menuIsOpen={true} onChange={handleAliasedAccountChange} isDisabled={false}/>
              </PageDialogMainPanel>

            ) : ["SELF_SIGNUP"].includes(step) ? (

              <PageDialogMainPanel title={intl.msg("signup_create_account_title", {brand: env.displayName})} alert={alert}>

                <div className="mb-3">
                  {intl.msg(hasSelfSignupEtcFields() ? "signup_direct_init_request_signup_text" : "signup_direct_init_self_signup_text", {brand: env.displayName})}
                </div>

                <FormGroups>

                  <FormGroup>
                    <FormGroup.Label text={intl.msg(`signup_request_full_name`)} description={intl.msg("signup_request_full_name_description")}/>
                    <FormGroup.Controls>
                      <input id="inp_fullName" className="form-control" autoFocus={true} style={{width: "100%"}} type="text" value={fullName} onChange={handleFullNameChange}/>
                    </FormGroup.Controls>
                  </FormGroup>

                  <FormGroup>
                    <FormGroup.Label text={intl.msg(`signup_request_email_address`)} description={intl.msg("signup_request_email_address_description")}/>
                    <FormGroup.Controls>
                      <input id="inp_emailAddress" className="form-control" style={{width: "100%"}} type="email" value={emailAddress} onChange={handleEmailAddressChange}/>
                    </FormGroup.Controls>
                  </FormGroup>


                  <FormGroup>
                    <FormGroup.Label htmlFor="inp_countryCode" text={intl.msg("signup_request_country")} description={intl.msg("signup_request_country_description")}/>
                    <FormGroup.Control>
                      <AsyncPaginate id="inp_countryCode" className="react-select" classNamePrefix="react-select" cacheOptions value={country} debounceTimeout={800} defaultOptions={true} loadOptions={loadCountries} placeholder={null} onChange={handleCountryChange} isDisabled={false}/>
                    </FormGroup.Control>
                  </FormGroup>

                </FormGroups>

                <div className="mt-3">
                  <ActionButton name={hasSelfSignupEtcFields() ? "next" : "continue"} flavor="primary" disabled={isBlankString(emailAddress) || !country} onClick={hasSelfSignupEtcFields() ? handleSignupRequestNextClick : generateVerifyEmail}/>
                </div>

                <div className="mt-4">
                  {intl.msg("accept_terms_by_continuing")}
                </div>

                <div className="mt-4" style={{borderTop: "1px solid var(--form-divider-color)", paddingTop: "20px"}}>
                  {intl.msg("already_have_an_account")}
                </div>

              </PageDialogMainPanel>

            ) : ["SELF_SIGNUP_PAGE_2"].includes(step) ? (

              <PageDialogMainPanel title={intl.msg("signup_create_account_title", {brand: env.displayName})} alert={alert}>

                <div className="mb-3">
                  {intl.msg("signup_direct_init_request_signup_page_2_text", {brand: env.displayName})}
                </div>

                <FormGroups>
                  {
                    env.selfSignupEtcFields?.map(f => {
                      const fn = f.toLowerCase()
                      const def = selfSignupEtcFieldDefs[f]
                      return (
                        <FormGroup>
                          <FormGroup.Label htmlFor={`inp_${fn}`} text={intl.msg(`signup_request_${fn}`, {brand: env.displayName})} description={intl.msg(`signup_request_${fn}_description`, {brand: env.displayName})}/>
                          <FormGroup.Controls>
                            {
                              ["URL"].includes(def?.type) ? (
                                <UrlInput id={`inp_${fn}`} value={etc[f]} onChange={handleEtcFieldInputChange(f)}/>
                              ) : ["TEXT", "EMAIL"].includes(def?.type) ? (
                                <>
                                  <input id={`inp_${fn}`} type={def?.type?.toLowerCase() || "text"} className="form-control" style={{width: "100%"}} value={etc[f]} onChange={handleEtcFieldInputChange(f)}/>
                                </>
                              ) : ["TEXTAREA"].includes(def?.type) ? (
                                <textarea id={`inp_${fn}`} className="form-control" style={{width: "100%"}} value={etc[f]} onChange={handleEtcFieldInputChange(f)}/>
                              ) : ["SELECT"].includes(def?.type) ? (
                                <Select id={`inp_${fn}`} className="react-select" classNamePrefix="react-select" options={def?.opts} value={getSelfSignupFieldOptionFromValue(f, etc[f])} placeholder={null} onChange={handleEtcFieldSelectChange(f)}/>
                              ) : (
                                <input id={`inp_${fn}`} type="text" className="form-control" style={{width: "100%"}} type="text" value={etc[f]} onChange={handleEtcFieldInputChange(f)}/>
                              )
                            }

                          </FormGroup.Controls>
                        </FormGroup>
                      )
                    })
                  }

                </FormGroups>

                <div className="d-flex flex-row gap-1 mt-3">
                  <ActionButton name={"previous"} onClick={handleSignupRequestPrevClick}/>
                  <ActionButton name={"continue"} flavor="primary" disabled={isBlankString(emailAddress) || !country} onClick={generateVerifyEmail}/>
                </div>

                <div className="mt-4">
                  {intl.msg("accept_terms_by_continuing")}
                </div>

                <div className="mt-4" style={{borderTop: "1px solid var(--form-divider-color)", paddingTop: "20px"}}>
                  {intl.msg("already_have_an_account")}
                </div>

              </PageDialogMainPanel>

            ) : ["SELF_SIGNUP_REGISTERED"].includes(step) ? (

              <PageDialogMainPanel title={intl.msg("signup_request_registered_title", {brand: env.displayName})} alert={alert}>
                <label className="mt-3">{intl.msg("signup_request_registered_text", {brand: env.displayName})}</label>
              </PageDialogMainPanel>

            ) : ["INVITED_SIGNUP"].includes(step) ? (

              signupCodeInfo ? (

                <PageDialogMainPanel title={intl.msg(`signup_${signupCodeInfo.signupType.toLowerCase()}_title`)} alert={alert}>
                  <p className="mt-3">
                    {
                      signupCodeInfo ? (
                        intl.msg(`signup_${signupCodeInfo.signupType.toLowerCase()}_text`, {
                          inviterUserName: signupCodeInfo.inviterUser?.displayName,
                          inviterTenantName: signupCodeInfo.inviterTenant?.tenantName,
                          inviteeTenantName: signupCodeInfo?.inviteeTenant?.tenantName,
                          inviteeEmailAddress: signupCodeInfo?.inviteeUser?.emailAddress,
                          referralCode: signupCodeInfo.signupCode?.toUpperCase(),
                          brandId: env.brandId
                        })
                      ) : (
                        <></>
                      )
                    }
                  </p>

                  <Div className="mt-1" hidden={!env.googleClientId}>
                    <GoogleButton
                      onSuccess={handleGoogleLoginSuccess}
                      onError={handleGoogleLoginError}
                      buttonText={intl.msg("signup_with_google")}/>
                  </Div>

                  <Div className="mt-2" hidden={!env.linkedinClientId}>
                    <LinkedInButton
                      onSuccess={handleLinkedInLoginSuccess}
                      onError={handleLinkedInLoginError}
                      buttonText={intl.msg("signup_with_linkedin")}/>
                  </Div>

                  <Div className="d-flex flex-row align-items-center mt-2 gap-1" hidden={!env.googleClientId && !env.microsoftClientId && !env.linkedinClientId}>
                    <span className="text-muted">-</span><span>or</span><span className="text-muted">-</span>
                  </Div>

                  <div className="mt-2">
                    {/*<input className="form-control" type="text" value={fullName} placeholder={intl.msg("signup_full_name_placeholder")} onChange={handleFullNameChange}/>*/}
                    <button className="btn-signin btn-signin-email mt-1" type="button" disabled={!emailAddress || emailAddress.trim().length === 0} onClick={generateVerifyEmail}>
                      <div className="btn-signin-icon">
                        <Icon name="envelope2"/>
                      </div>
                      <span className="btn-signin-text">{intl.msg("signup_with_email")}</span>
                    </button>
                  </div>
                  <div className="mt-4">
                    {intl.msg("accept_terms_by_continuing")}
                  </div>
                  <div className="mt-4" style={{borderTop: "1px solid var(--form-divider-color)"}}>
                    {intl.msg("already_have_an_account")}
                  </div>
                </PageDialogMainPanel>

              ) : (
                <PageDialogMainPanel alert={alert}>
                  {
                    !alert &&
                      <label className="mt-3">{intl.msg("checking", {brand: env.displayName})}</label>
                  }
                </PageDialogMainPanel>
              )

            ) : (
              <></>
            )

          }

        </PageDialog>
      </PageDialogContainer>
    </MainContainer>
  )
}

